import React from 'react';
import { FadeIn } from './FadeIn';
import { MapPin, Phone } from 'lucide-react';
interface CallToActionProps {
  onBook: () => void;
  lang: 'en' | 'es';
}
function FacebookIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-54">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-55" />
    </svg>;
}
function InstagramIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-56">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-57" />
    </svg>;
}
function WhatsAppIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-[#25D366]" data-id="element-58">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-59" />
    </svg>;
}
export function CallToAction({
  onBook,
  lang
}: CallToActionProps) {
  return <footer className="bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-60">
      {/* Main CTA Area */}
      <div className="py-24 md:py-32 relative z-10" data-id="element-61">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-62">
          <FadeIn data-id="element-63">
            <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl mb-8 leading-tight" data-id="element-64">
              {lang === 'es' ? <>
                  Tu Silla Te Espera.
                  <br data-id="element-65" />
                  <span className="text-brand-gold italic" data-id="element-66">
                    Tu Versión Más Bella Aún No Ha Llegado.
                  </span>
                </> : <>
                  Your Chair Is Waiting.
                  <br data-id="element-67" />
                  <span className="text-brand-gold italic" data-id="element-68">
                    Your Most Beautiful Self Hasn't Shown Up Yet.
                  </span>
                </>}
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-69">
            <button onClick={onBook} className="mt-8 bg-brand-gold hover:bg-brand-gold/90 text-brand-dark px-10 py-5 text-lg rounded-none font-sans font-medium tracking-wide transition-all duration-300 transform hover:-translate-y-1" data-id="element-70">
              {lang === 'es' ? 'Reserva Tu Cita' : 'Book Your Appointment'}
            </button>
          </FadeIn>

          {/* Social Media */}
          <FadeIn delay={0.3} data-id="element-71">
            <div className="mt-12 flex items-center justify-center gap-5" data-id="element-72">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-brand-cream/40 hover:text-[#1877F2] transition-colors duration-300" aria-label="Facebook" data-id="element-73">
                <FacebookIcon data-id="element-74" />
              </a>
              <a href="https://instagram.com/isashybeauty" target="_blank" rel="noopener noreferrer" className="text-brand-cream/40 hover:text-[#E4405F] transition-colors duration-300" aria-label="Instagram" data-id="element-75">
                <InstagramIcon data-id="element-76" />
              </a>
              <a href="https://wa.me/12035550123" target="_blank" rel="noopener noreferrer" className="text-brand-cream/40 hover:text-[#25D366] transition-colors duration-300" aria-label="WhatsApp" data-id="element-77">
                <WhatsAppIcon data-id="element-78" />
              </a>
            </div>
          </FadeIn>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-brand-cream/10 bg-[#111] py-12 relative z-10" data-id="element-79">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-80">
          <div className="text-center md:text-left" data-id="element-81">
            <span className="text-brand-gold tracking-[0.2em] text-sm font-medium uppercase block mb-2" data-id="element-82">
              ISASHY BEAUTY CENTER
            </span>
            <p className="text-brand-cream/50 text-sm font-sans" data-id="element-83">
              © {new Date().getFullYear()} ISASHY Beauty Center. All rights
              reserved.
            </p>
          </div>

          <div className="flex items-center gap-6" data-id="element-84">
            <div className="flex flex-col sm:flex-row items-center gap-3 text-brand-cream/70 font-sans text-sm" data-id="element-85">
              <div className="flex items-center gap-2" data-id="element-86">
                <MapPin className="w-4 h-4 text-brand-gold" data-id="element-87" />
                <p data-id="element-88">1407 North Main St, Waterbury, CT 06704</p>
              </div>
              <span className="hidden sm:block text-brand-cream/20" data-id="element-89">|</span>
              <a href="tel:9172090303" className="flex items-center gap-2 hover:text-brand-cream transition-colors" data-id="element-90">
                <Phone className="w-4 h-4 text-brand-gold" data-id="element-91" />
                <p data-id="element-92">(917) 209-0303</p>
              </a>
            </div>
            <div className="flex items-center gap-3" data-id="element-93">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-brand-cream/30 hover:text-[#1877F2] transition-colors" aria-label="Facebook" data-id="element-94">
                <FacebookIcon data-id="element-95" />
              </a>
              <a href="https://instagram.com/isashybeauty" target="_blank" rel="noopener noreferrer" className="text-brand-cream/30 hover:text-[#E4405F] transition-colors" aria-label="Instagram" data-id="element-96">
                <InstagramIcon data-id="element-97" />
              </a>
              <a href="https://wa.me/12035550123" target="_blank" rel="noopener noreferrer" className="text-brand-cream/30 hover:text-[#25D366] transition-colors" aria-label="WhatsApp" data-id="element-98">
                <WhatsAppIcon data-id="element-99" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}